import { useQuery } from '@apollo/client';
import { ACCREDITATIONS, ACCREDITATIONS_FOR_CLIENT } from '@src/graphql/queries/accreditation';
import { useMemo } from 'react';
/**
 * Hook to fetch accreditations.
 * - If clientId is provided: uses accreditationsForClient query (non-admin)
 * - If clientId is NOT provided: uses accreditations query (admin-only)
 */
export const useAccreditations = (props) => {
    // Choose the appropriate query based on whether clientId is provided
    const query = props?.clientId ? ACCREDITATIONS_FOR_CLIENT : ACCREDITATIONS;
    const variables = props?.clientId
        ? { clientId: props.clientId } // Use clientId for non-admin query
        : { spec: undefined }; // Use spec for admin query
    const { data, loading, error } = useQuery(query, {
        variables,
        skip: props?.skip,
    });
    // Extract accreditations from the appropriate response field
    const accreditations = useMemo(() => (data?.accreditations || data?.accreditationsForClient || []), [data]);
    const accreditationsOptions = useMemo(() => accreditations.map(acc => ({
        value: acc.id,
        label: acc.name,
    })), [accreditations]);
    return {
        accreditations,
        accreditationsOptions,
        loading,
        error,
    };
};
